
/** 页面进入时间 */
const startTime = new Date().getTime();

/** 页面登陆最大持续时间 **/
export const LOGIN_MAX_DURATION = 3000;

/**
 * 判断页面是否已登陆过，这里暂时用3s来区分是页面初始化还是后续操作
 * @returns
 */
export function checkLoggedIn() {
  return new Date().getTime() - startTime >= LOGIN_MAX_DURATION;
}
